import { authHttpClientGet } from "./my_axios";

export async function getExportContracts(store) {
  return await authHttpClientGet(store, "/export-data/contracts");
}

export async function getExportCompanies(store) {
  return await authHttpClientGet(store, "/export-data/companies");
}

export async function getExportDrivers(store) {
  return await authHttpClientGet(store, "/export-data/drivers");
}

export async function getExportVehicles(store) {
  return await authHttpClientGet(store, "/export-data/vehicles");
}

export async function getExportVehicleTypes(store) {
  return await authHttpClientGet(store, "/export-data/vehicle-types");
}

export async function getExportContractJob(store, params) {
  let uri = `/export-data/contract-job?startDate=${params.startDate}&endDate=${params.endDate}`;
  if (params.contractId)
    uri += `&contractId=${encodeURIComponent(params.contractId)}`;
  if (params.status) uri += `&status=${encodeURIComponent(params.status)}`;
  if (params.company) uri += `&company=${encodeURIComponent(params.company)}`;
  if (params.driverId)
    uri += `&driverId=${encodeURIComponent(params.driverId)}`;
  if (params.vehicleId)
    uri += `&vehicleId=${encodeURIComponent(params.vehicleId)}`;
  if (params.vehicleType)
    uri += `&vehicleType=${encodeURIComponent(params.vehicleType)}`;
  if (params.direction)
    uri += `&direction=${encodeURIComponent(params.direction)}`;
  if (params.exportType)
    uri += `&exportType=${encodeURIComponent(params.exportType)}`;
  return await authHttpClientGet(store, uri);
}

export async function getExportContractJobAdminEnded(store, params) {
  let uri = `/export-data/contract-job-admin-ended?startDate=${params.startDate}&endDate=${params.endDate}`;
  if (params.contractId)
    uri += `&contractId=${encodeURIComponent(params.contractId)}`;
  if (params.status) uri += `&status=${encodeURIComponent(params.status)}`;
  if (params.company) uri += `&company=${encodeURIComponent(params.company)}`;
  if (params.driverId)
    uri += `&driverId=${encodeURIComponent(params.driverId)}`;
  if (params.vehicleId)
    uri += `&vehicleId=${encodeURIComponent(params.vehicleId)}`;
  if (params.vehicleType)
    uri += `&vehicleType=${encodeURIComponent(params.vehicleType)}`;
  if (params.direction)
    uri += `&direction=${encodeURIComponent(params.direction)}`;
  return await authHttpClientGet(store, uri);
}

// User export
export async function getExportEmpStatuses(store) {
  return await authHttpClientGet(store, "/export-data/emp-statuses");
}

export async function getExportPositions(store) {
  return await authHttpClientGet(store, "/export-data/positions");
}

export async function getExportUser(store, params) {
  let uri = `/export-data/user?exportType=${params.exportType || "short"}`;
  if (params.empStatus)
    uri += `&empStatus=${encodeURIComponent(params.empStatus)}`;
  if (params.position)
    uri += `&position=${encodeURIComponent(params.position)}`;
  if (params.joinStartDate)
    uri += `&joinStartDate=${params.joinStartDate}`;
  if (params.joinEndDate)
    uri += `&joinEndDate=${params.joinEndDate}`;
  return await authHttpClientGet(store, uri);
}

export async function getExportUserTimeoff(store, params) {
  let uri = "/export-data/user-timeoff?_=1";
  if (params.startDate) uri += `&startDate=${params.startDate}`;
  if (params.endDate) uri += `&endDate=${params.endDate}`;
  if (params.userId)
    uri += `&userId=${encodeURIComponent(params.userId)}`;
  if (params.timeoffType)
    uri += `&timeoffType=${encodeURIComponent(params.timeoffType)}`;
  if (params.status)
    uri += `&status=${encodeURIComponent(params.status)}`;
  if (params.year) uri += `&year=${encodeURIComponent(params.year)}`;
  return await authHttpClientGet(store, uri);
}

export async function getExportUserPayment(store, params) {
  let uri = "/export-data/user-payment?_=1";
  if (params.startDate) uri += `&startDate=${params.startDate}`;
  if (params.endDate) uri += `&endDate=${params.endDate}`;
  if (params.driverId)
    uri += `&driverId=${encodeURIComponent(params.driverId)}`;
  if (params.contractId)
    uri += `&contractId=${encodeURIComponent(params.contractId)}`;
  return await authHttpClientGet(store, uri);
}

export async function getExportUserVehicleHistory(store, params) {
  let uri = "/export-data/user-vehicle-history?_=1";
  if (params.startDate) uri += `&startDate=${params.startDate}`;
  if (params.endDate) uri += `&endDate=${params.endDate}`;
  if (params.driverId)
    uri += `&driverId=${encodeURIComponent(params.driverId)}`;
  return await authHttpClientGet(store, uri);
}

// Vehicle export
export async function getExportVehicle(store, params) {
  let uri = `/export-data/vehicle?exportType=${params.exportType || "short"}`;
  if (params.status) uri += `&status=${encodeURIComponent(params.status)}`;
  if (params.type) uri += `&type=${encodeURIComponent(params.type)}`;
  if (params.licenseType)
    uri += `&licenseType=${encodeURIComponent(params.licenseType)}`;
  return await authHttpClientGet(store, uri);
}

export async function getExportVehicleInsurance(store, params) {
  let uri = "/export-data/vehicle-insurance?_=1";
  if (params.vehicleId)
    uri += `&vehicleId=${encodeURIComponent(params.vehicleId)}`;
  if (params.expiryStartDate)
    uri += `&expiryStartDate=${params.expiryStartDate}`;
  if (params.expiryEndDate) uri += `&expiryEndDate=${params.expiryEndDate}`;
  return await authHttpClientGet(store, uri);
}

export async function getExportVehicleAct(store, params) {
  let uri = "/export-data/vehicle-act?_=1";
  if (params.vehicleId)
    uri += `&vehicleId=${encodeURIComponent(params.vehicleId)}`;
  if (params.expiryStartDate)
    uri += `&expiryStartDate=${params.expiryStartDate}`;
  if (params.expiryEndDate) uri += `&expiryEndDate=${params.expiryEndDate}`;
  return await authHttpClientGet(store, uri);
}

export async function getExportVehicleTax(store, params) {
  let uri = "/export-data/vehicle-tax?_=1";
  if (params.vehicleId)
    uri += `&vehicleId=${encodeURIComponent(params.vehicleId)}`;
  if (params.expiryStartDate)
    uri += `&expiryStartDate=${params.expiryStartDate}`;
  if (params.expiryEndDate) uri += `&expiryEndDate=${params.expiryEndDate}`;
  return await authHttpClientGet(store, uri);
}

export async function getExportVehicleFuel(store, params) {
  let uri = "/export-data/vehicle-fuel?_=1";
  if (params.vehicleId)
    uri += `&vehicleId=${encodeURIComponent(params.vehicleId)}`;
  if (params.status) uri += `&status=${encodeURIComponent(params.status)}`;
  if (params.startDate) uri += `&startDate=${params.startDate}`;
  if (params.endDate) uri += `&endDate=${params.endDate}`;
  return await authHttpClientGet(store, uri);
}

export async function getExportVehicleFeedcard(store, params) {
  let uri = "/export-data/vehicle-feedcard?_=1";
  if (params.vehicleId)
    uri += `&vehicleId=${encodeURIComponent(params.vehicleId)}`;
  return await authHttpClientGet(store, uri);
}
